/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Valves_Demand_HelpInputs */



/**
* | output |
* | --- |
* | "Number of open and connected th. heads" |
*
* @param {Valves_Demand_HelpInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const valves_demand_help = /** @type {((inputs?: Valves_Demand_HelpInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Valves_Demand_HelpInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Number of open and connected th. heads")
	return /** @type {LocalizedString} */ ("Nombre de têtes th. ouvertes et connectées")
});